import { Tooltip } from "@/components/ui/tooltip";
import { DriverListEntity } from "@/pages/config/drivers/schema/drivers.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";

interface Props {
  item: DriverListEntity;
  handleDetail: (id: any) => void;
}

export const DriversActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Editar</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <PenLine
          cursor="pointer"
          onClick={() => handleDetail(item?.id)}
          data-testid="drivers-actions-edit"
        />
      </Flex>
    </Tooltip>
  );
};
